import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';

@Component({
    selector: 'ngc-slick-id',
    templateUrl: './slick-id.component.html',
    styleUrls: ['./slick-id.component.scss']
})
export class SlickIdComponent implements OnInit, OnChanges {

    @Input() value: string;
    @Input() allowCopy: boolean;
    @Input() disableTooltip = false;
    @Input() naTitle: string;
    @Input() valueLengthToBeChecked: number;
    @Input() valueLengthToBeShowed: number;
    @Input() routerLink: string;

    slickIdValue: string;
    hasSlickId = false;

    readonly separator = '**';
    readonly DEFAULT_VALUE_LENGTH_TO_BE_CHECKED = 12;
    readonly DEFAULT_VALUE_LENGTH_TO_BE_SHOWED = 4;

    constructor(public snackBar: MatSnackBar) {
        this.valueLengthToBeChecked = this.DEFAULT_VALUE_LENGTH_TO_BE_CHECKED;
        this.valueLengthToBeShowed = this.DEFAULT_VALUE_LENGTH_TO_BE_SHOWED;
    }

    ngOnInit() {
    }

    ngOnChanges(changes: any): void {
        if (changes.value) {
            this.allowCopy = (this.allowCopy === undefined) ? !!this.value : this.allowCopy;
            this.slickIdValue = this.value;
            if (this.value && (this.value.length > this.valueLengthToBeChecked)) {
                this.hasSlickId = true;
                this.slickIdValue = this.value.substr(0, this.valueLengthToBeShowed) + this.separator + this.value.substr(-this.valueLengthToBeShowed);
            }
        }
    }

    onCopy() {
        this.snackBar.open('Copied to Clipboard', '', {duration: 1000});
    }
}
